import cx from 'classnames';
import Trans from 'next-translate/Trans';
import BPImage from '../../../ui/v2/image';
import IconCircleI from '../../../ui/icons/circle-i-new-version';
import IconCircleIRounded from '../../../ui/icons/circle-i-rounded';

const IsSold = ({ productDetail }) => {
  return (
    <div className="container mx-auto text-center flex flex-row gap-4 justify-center bg-red-10 items-center">
      <div className="flex flex-shrink-0 w-4 h-4">
        <IconCircleIRounded className="text-red-100 w-4 h-4"></IconCircleIRounded>
      </div>
      <p className={cx('text-neutral-80')}>
        <Trans
          i18nKey="product:sold_part"
          values={{
            part: `${productDetail.part.name} ${productDetail.car.brand_name} ${
              productDetail.car.model_name
            } ${productDetail.car.version_name || ''}`,
          }}
          components={{ b: <b /> }}
        />
      </p>
    </div>
  );
};

export default IsSold;
